module.exports = __webpack_public_path__ + "img/thumbnail_Axolotl_u_leucistic.2cb2753f.png";